export const gaTrackingConfig: {
  [env in string]: string
} = {
  staging: 'UA-32127122-2',
  production: 'UA-32127122-1',
}
